export const environment = {
    production: true,
    apiUrl: 'https://dashboard-refeezy.aknana.com/api',
    fcm_token:'eyJ0eXAiOiJKV1QiLCJhbGciOi',
    platform:'web',
    taxVat:15,
};
